module.exports = __webpack_public_path__ + "static/11-3d180e54e45683e26b436ebdef87a29e.jpg";